import React from "react";
function tableRow(id, bazaar, openTime, closeTime) {
  this.id = id;
  this.bazaar = bazaar;
  this.openTime = openTime;
  this.closeTime = closeTime;
}
const timeTableData = [
  new tableRow("01", "Madhur Morning", "11:30:00", "12:30:00"),
  new tableRow("02", "Madhur Day", "13:15:00", "14:15:00"),
  new tableRow("03", "Kamdhenu Day", "15:00:00", "17:00:00"),
  new tableRow("04", "Madhur Evening", "15:00:00", "17:00:00"),
  new tableRow("05", "Dhanlaxmi Day", "14:00:00", "16:15:00"),
  new tableRow("06", "Kalyan", "18:30:00", "19:45:00"),
  new tableRow("07", "Dhanlaxmi Night", "20:25:00", "22:25:00"),
  new tableRow("08", "Madhur Night", "20:30:00", "22:30:00"),
  new tableRow("09", "Madhur Shubhank", "21:15:00", "23:15:00"),
  new tableRow("10", "Kamdhenu Night	", "21:00:00", "23:00:00"),
  new tableRow("11", "Main", "21:40:00", "00:05:00"),
  new tableRow("12", "Dhanlaxmi Morning	", "11:15:00", "12:15:00"),
];

const TimeTable = ({ gamesList }) => {
  const TableRow = ({ data }) => {
    return (
      <tr className="py-1 border-b border-black cursor-pointer hover:text-green-900 hover:bg-green-100">
        <td className="lg:text-lg text-2xl px-2 py-1 text-left sm:pr-10">{data.game_name}</td>
        <td className="lg:text-lg text-2xl sm:px-10 py-1 ">{data.game_from_time} </td>
        <td className="lg:text-lg text-2xl sm:px-10 py-1 ">{data.game_to_time}</td>
      </tr>
    );
  };

  return (
    <div className="pt-4">
      <h2 className="py-1 text-2xl lg:text-lg text-white bg-teal-950">Time Table </h2>

      <div className="mx-auto lg:max-w-[80%] max-w-[100%] mt-5">
        <table className="lg:w-auto w-[100%] border border-black mx-auto">
          <thead>
            <tr className="bg-red-900 text-sky-400">
              <td className="text-left text-2xl lg:text-lg py-1 px-4">BAZAAR</td>
              <td className="text-left text-2xl lg:text-lg py-1 px-4">OPEN TIME</td>
              <td className="text-left text-2xl lg:text-lg py-1 px-4">CLOSE TIME</td>
            </tr>
          </thead>
          <tbody className="">
            {gamesList?.map((ele) => (
              <TableRow data={ele} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimeTable;
